import { z } from 'zod';
import { OnboardingModeSchema } from './onboarding.js';
export const VersionInfoSchema = z.object({
    version: z.string(),
    builtAt: z.string().nullable(),
    commit: z.string(),
    mode: OnboardingModeSchema,
});
//# sourceMappingURL=version.js.map